import React, {useState, useRef} from "react";
import {CircularProgressCustom} from "./common-components/CircularProgressCustom";
import {useQuery} from "@apollo/react-hooks";
import {GET_CUSTOM_PROJECTS} from "./../../services/graphql-query";
import {Container, Row, Col} from "react-bootstrap";
import {apiUrl} from "./../../services/constants";
import "../../css/app.css";
import {PdfViewer} from "./common-components/PdfViewer";
import {BiArrowBack} from "react-icons/bi";
import {MdDownload} from "react-icons/md";


const CustomWork = () => {
    const {loading, error, data} = useQuery(GET_CUSTOM_PROJECTS);
    const [isZoomPdf, setZoomPdf] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');

    const onClosePdf = () => {
        setZoomPdf(false);
        setPdfUrl('');
    }

    const onZoomPdf = (pdfUrl) => {
        setZoomPdf(true);
        setPdfUrl(pdfUrl);
    };


    if (loading) return <CircularProgressCustom/>;

    if (error)
        return (
            <>
                <h1>Sorry... We have some error</h1>
            </>
        );


    const renderAll = () => {

        return (
            <>
                <h2>{title}</h2>
                <Row>
                    {
                        data.customWorks.data.map((item, key) => {
                            return item.attributes?.PDFFile.data?.map((file) => {
                                return (
                                    <Col md={4} key={key}>
                                        <PdfViewer url={apiUrl + file.attributes?.url} onZoomPdf={onZoomPdf} isZoom={false}/>
                                    </Col>
                                );
                            });
                        })
                    }
                </Row>
            </>
        );
    }

    const renderOne = () => {
        return (
            <>
               <Row>
                   <Col>
                       <a className="btn btn-warning pull-right" href={pdfUrl} download>Download <MdDownload style={{display: 'inline-block'}}/></a>
                       <div className="btn btn-primary" style={{position: "fixed", bottom: 20, right: 50, zIndex: 10000}} onClick={onClosePdf}><BiArrowBack style={{display: 'inline-block'}}/>Back to List </div>
                   </Col>
               </Row>
                <Row>
                    <PdfViewer url={pdfUrl} isZoom={true} key={pdfUrl}/>
                </Row>
            </>
        );
    }

    let title = '';
    if(data.customWorks.data.length > 0) {
        title = data.customWorks.data[0].attributes?.Title;
    }

    //item.attributes?.PDFFile?.data?.attributes?.name
    return (
        <Container className="custom-works-container">

            {isZoomPdf ? renderOne() : renderAll()}
        </Container>
    );
};

export default CustomWork;
